import { MenuItem } from 'primeng/api';
import { RailMyBoxRoles } from '@railmybox/auth';

export interface SupportMenuItem extends MenuItem {
  roles?: RailMyBoxRoles[];
  restricted?: boolean;
  items?: SupportMenuItem[];
}

export const supportMenuItems: SupportMenuItem[] = [
  {
    label: '.helpdesk',
    icon: 'assets/icons/navigation/support/helpdesk.svg',
    route: ['/', 'support', 'disposition'],
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING, RailMyBoxRoles.TYPIST],
  },
  {
    label: '.train-management',
    icon: 'assets/icons/navigation/support/train-visits.svg',
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING, RailMyBoxRoles.TYPIST, RailMyBoxRoles.OPERATOR],
    items: [
      { label: '.trainSchedule', routerLink: ['/', 'support', 'train-visits'] },
      { label: '.capacity-management', routerLink: ['/', 'support', 'capacity-management'] },
    ],
  },
  {
    label: '.wishlist',
    icon: 'assets/icons/navigation/support/wishlist.svg',
    route: ['/', 'support', 'wishlist'],
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.TYPIST],
  },
  {
    label: '.pricing',
    icon: 'assets/icons/navigation/support/pricing.svg',
    roles: [RailMyBoxRoles.PRICING],
    items: [
      { label: '.tariff-scales', routerLink: ['/', 'support', 'tariff-scales'] },
      { label: '.basis-zones', routerLink: ['/', 'support', 'basis-zones'] },
      { label: '.tariff-zones', routerLink: ['/', 'support', 'tariff-zones'] },
      { label: '.customer-tariffs', routerLink: ['/', 'support', 'customer-tariffs'] },
      { label: '.customer-discounts', routerLink: ['/', 'support', 'customer-discount'] },
      { label: '.extra-charges', routerLink: ['/', 'support', 'extra-charges'] },
      { label: '.masterdata.tollBases', routerLink: ['/', 'support', 'toll-bases'] },
    ],
  },
  {
    label: '.accounting',
    icon: 'assets/icons/navigation/support/accounting.svg',
    roles: [RailMyBoxRoles.ACCOUNTING],
    items: [
      { label: '.posting-months', routerLink: ['/', 'support', 'posting-months'] },
      { label: '.incoming-costs', routerLink: ['/', 'support', 'incoming-costs'] },
      { label: '.summed-costs', routerLink: ['/', 'support', 'summed-costs'] },
      { label: '.summed-reserves', routerLink: ['/', 'support', 'summed-reserves'] },
      { label: '.incoming-invoices', routerLink: ['/', 'support', 'incoming-invoices'] },
    ],
  },
  {
    label: '.invoices',
    icon: 'assets/icons/navigation/support/invoices.svg',
    route: ['/', 'support', 'invoices'],
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING],
  },
  {
    label: '.customers',
    icon: 'assets/icons/navigation/support/customers.svg',
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING, RailMyBoxRoles.TYPIST],
    items: [
      { label: '.customers', routerLink: ['/', 'support', 'customers'] },
      { label: '.customer-groups', routerLink: ['/', 'support', 'customer-groups'] },
      { label: '.debtors', routerLink: ['/', 'support', 'debtors'] },
    ],
  },
  {
    label: '.masterdata.title',
    icon: 'assets/icons/navigation/support/masterdata.svg',
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING, RailMyBoxRoles.TYPIST, RailMyBoxRoles.OPERATOR],
    items: [
      {
        label: '.masterdata.trains',
        routerLink: ['/', 'support', 'trains'],
        roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING, RailMyBoxRoles.OPERATOR],
      },
      {
        label: '.masterdata.stations',
        routerLink: ['/', 'support', 'stations'],
        roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING],
      },
      {
        label: '.masterdata.services',
        routerLink: ['/', 'support', 'services'],
        roles: [RailMyBoxRoles.PRICING, RailMyBoxRoles.ACCOUNTING],
      },
      {
        label: '.masterdata.isoCodes',
        routerLink: ['/', 'support', 'iso-codes'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.ports',
        routerLink: ['/', 'support', 'ports'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.depots',
        routerLink: ['/', 'support', 'depots'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.shippingLine',
        routerLink: ['/', 'support', 'shipping-line'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.customs-offices',
        routerLink: ['/', 'support', 'customs-offices'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.currency',
        routerLink: ['/', 'support', 'currencies'],
        roles: [RailMyBoxRoles.SUPPORT],
      },
      {
        label: '.masterdata.operators',
        routerLink: ['/', 'support', 'operators'],
        roles: [],
      },
    ],
  },
  {
    label: '.news',
    icon: 'assets/icons/navigation/support/news.svg',
    route: ['/', 'support', 'news'],
    roles: [RailMyBoxRoles.PRICING],
  },
  {
    label: '.claims',
    icon: 'assets/icons/navigation/support/claims.svg',
    route: ['/', 'support', 'claims'],
    roles: [RailMyBoxRoles.SUPPORT, RailMyBoxRoles.TYPIST],
  },
];
